import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstanse";

export interface OrderRequest {
    idx: string;
    c_code: string;
    // c_branch: string;
    c_req_dept: string;
    s_kind: string;
    s_pay_kind: string;
    s_cnt: string;
    s_weight: string;
    s_pay_company_code: string;
    s_pay_company: string;
    s_pay_tel: string;
    s_pay_name: string;
    s_pay_post: string;
    s_pay_address: string;
    s_pay_address_detail: string;
    a_company: string;
    a_tel: string;
    a_part: string;
    a_part_sn: string;
    a_name: string;
    a_request: string;
    a_request2: string;
    f_c_code: string;
    f_company: string;
    f_tel: string;
    f_name: string;
    f_mobile: string;
    f_post: string;
    f_address: string;
    f_address_detail: string;
    f_dam_code: string;
    t_c_code: string;
    t_company: string;
    t_tel: string;
    t_name: string;
    t_mobile: string;
    t_post: string;
    t_address: string;
    t_address_detail: string;
}

export interface OrderResponse {
    statusCode: number;
    message: string;
}

export const usePutAddOrder = (
    successCallback?: (data: OrderResponse) => void,
): UseMutationResult<OrderResponse, Error, OrderRequest, unknown> => {
    const queryClient = useQueryClient();

    return useMutation<OrderResponse, Error, OrderRequest>({
        mutationFn: async (orderData: OrderRequest) => {
            const response = await axiosInstance.put(enum_api_uri.tmp_edit, orderData);
            return response.data;
        },
        onSuccess: data => {
            queryClient.invalidateQueries({ queryKey: ["usePostTmpList"] });
            successCallback?.(data);
        },
    });
};
